export const PAYMENT_FAILED = 'payment-failed' as const;
export const PAYMENT_SUCCESS = 'payment-success' as const;

export type PaymentStatus = null | typeof PAYMENT_FAILED | typeof PAYMENT_SUCCESS;
